<app-panel-body>
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        @if (summaryLoading()) {
        <p class="text-sm text-secondary-text">{{ 'money-out-payment-panel.loading' | transloco }}</p>
        }

        @if (paymentSuccess()) {
        <app-inline-alert severity="success" [message]="'money-out-payment-panel.success' | transloco" />
        } @else {
        <!-- <div class="flex flex-col gap-3 text-sm text-primary-text">
            <p>{{ 'money-out-payment-panel.intro.p1' | transloco }}</p>
            <p>{{ 'money-out-payment-panel.intro.p2' | transloco }}</p>
          </div> -->



      
        <div class="flex flex-col gap-3">
          @if (selectedMethod() && !paymentSuccess()) {
            <div class="flex shrink-0 ">
              <app-button variant="icon" (clicked)="clearMethod()">
                <fa-icon class="text-lg" [icon]="['fas', 'arrow-left']" />
              </app-button>
            </div>
            }
          @if (!selectedMethod() || selectedMethod() == 'credit-card') {
          <button type="button"
            class="flex cursor-pointer items-center gap-4 rounded-md border border-primary-border bg-primary-bg px-4 py-3 text-left transition-colors hover:bg-secondary-bg"
           (click)="selectMethod('credit-card')">
            <fa-icon [icon]="['far', 'credit-card']" class="text-xl text-teal" />
            <div class="flex-1">
              <div class="text-lg font-semibold text-primary-text">
                {{ 'money-out-payment-panel.methods.credit-card.title' | transloco }}
              </div>
              <div class="text-sm text-secondary-text">
                {{ 'money-out-payment-panel.methods.credit-card.description' | transloco }}
              </div>
            </div>
          </button>
          }
          @if (!selectedMethod() || selectedMethod() == 'ach') {
          <button type="button"
            class="flex cursor-pointer items-center gap-4 rounded-md border border-primary-border bg-primary-bg px-4 py-3 text-left transition-colors hover:bg-secondary-bg"
            (click)="selectMethod('ach')">
            <fa-icon [icon]="['far', 'building-columns']" class="text-xl text-teal" />
            <div class="flex-1">
              <div class="text-lg font-semibold text-primary-text">
                {{ 'money-out-payment-panel.methods.ach.title' | transloco }}
              </div>
              <div class="text-sm text-secondary-text">
                {{ 'money-out-payment-panel.methods.ach.description' | transloco }}
              </div>
            </div>
          </button>
          }
        </div>

        @if(!selectedMethod()) {
        <app-card background="secondary">
          <p class="font-semibold">{{ 'money-out-payment-panel.check-by-mail.title' | transloco }}</p>
          <p class="mt-2">
            {{ 'money-out-payment-panel.check-by-mail.org-name' | transloco }}<br />
            {{ 'money-out-payment-panel.check-by-mail.line1' | transloco }}<br />
            {{ 'money-out-payment-panel.check-by-mail.line2' | transloco }}
          </p>
        </app-card>
        }
        }
        @if ( selectedMethod() && canShowStripeFlow() && stripeConfig() && billingDetails() && stripePaymentMethod()) {
        <app-stripe-payment-element [config]="stripeConfig()!" [paymentMethod]="stripePaymentMethod()!"
          [billingDetails]="billingDetails()!" [fullPaymentAmountCents]="fullPaymentAmountCents()"
          (paymentSucceeded)="onPaymentSucceeded()" />
        }

      </app-content-container>
    </div>


  </div>
</app-panel-body>